class Megamenu {
  constructor() {
    this.toggleMenu();
  }

  toggleMenu() {
    const menus = document.querySelectorAll('.header .header__inline-menu details');
    const mediaQuery = window.matchMedia('(max-width="768px")');

    for (let i = 0; i < menus.length; i++) {
      const menu = menus[i];
      menu.addEventListener('mouseover', (evt) => {
        const detail = evt.target.closest('details');
        detail.setAttribute('open', '');
      });

      menu.addEventListener('mouseout', (evt) => {
        const detail = evt.target.closest('details');
        detail.removeAttribute('open');
      });

      if (mediaQuery.matches) {
        menu.addEventListener('touchstart', (evt) => {
          const detail = evt.target.closest('details');
          detail.setAttribute('open', '');
        });
      }
    }
  }
}

export default Megamenu;
